<template>
  <div class="login-view">
    <div>
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
        <v-expand-transition>
          <v-card
            v-show="expand"
            v-bind="cardProps"
          >
            <h2 v-show="expand" class="mb-4">Iniciar sesión</h2>
            <div>
              <v-text-field
                v-bind="defaultFieldProps"
                v-model="email"
                :rules="[rules.required, rules.email]"
                label="E-mail"
              ></v-text-field>
            </div>

            <div>
              <v-text-field
                v-bind="defaultFieldProps"
                v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                @click:append="show1 = !show1"
                label="Contraseña"
                :rules="[rules.required]"
              ></v-text-field>
            </div>
            <v-alert v-if="loginError" dense type="error">
              {{ errorMsg }}
            </v-alert>
            <v-btn 
              v-bind="defaultButtonProps"
              :disabled="disableBtn" 
              type="submit"
            >
              Entrar
            </v-btn>
          </v-card>
        </v-expand-transition>
        <v-expand-transition>
          <v-card
            v-show="expand2"
            v-bind="cardProps"
          >
            <h2 class="mb-4">Selecciona un estudio</h2>

            <div>
              <v-select
                v-bind="defaultFieldProps"
                :items="items"
                label="Selecciona"
                item-text="name"
                item-value="number"
                v-model="select"
              ></v-select>
            </div>
            <v-alert v-if="loginError" dense type="error">
              {{ errorMsg }}
            </v-alert>
            <v-btn
              v-bind="defaultButtonProps"
              :disabled="select == null"
              @click="submitStudio"
            >
              Entrar
            </v-btn>
          </v-card>
        </v-expand-transition>
        
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-form>
    </div>

    <v-overlay :value="overlay2">
      <v-card flat class="mx-auto px-10 my-auto d-flex flex-column justify-center" max-width="470" height="150px">
        <v-card-title>{{ dialogMsg }}</v-card-title>
        <v-progress-linear
          color="admiraGreen"
          indeterminate
          rounded
          height="7"
        ></v-progress-linear>
      </v-card>
    </v-overlay>

    <MAFDialog
      ref="mfaDialog"
      @verified="handleMfaVerified"
      @cancelled="handleMfaCancelled"
      :token="totpToken"
    ></MAFDialog>

    <footer class="build-tag text-caption text--disabled">{{ buildTag }}</footer>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import MAFDialog from "@/dialogs/MAFDialog.vue";
import { socketAutoConnectDisabled } from "@/socket";

export default {
  name: 'LoginView',
  
  components: {
    MAFDialog
  },

  data() {
    return {
      valid: false,
      email: "",
      password: "",
      show1: false,
      rules: {
        required: (value) => !!value || "Campo requerido.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Ingrese un e-mail valido.";
        },
      },
      loginError: false,
      expand: false,
      expand2: false,
      select: null,
      items: [
        { text: "Estudio 1", studio: 1 },
        { text: "Estudio 2", studio: 2 },
        { text: "Estudio 3", studio: 3 },
      ],
      overlay: false,
      errorMsg: "",
      overlay2: false,
      dialogMsg: "Esperando confirmación del técnico",
      loginResponse: null,
      totpToken: '',
    };
  },

  computed: {
    ...mapState(["accessRemote", "currentUser"]),
    
    disableBtn() {
      return this.email.length == 0 || this.password.length == 0;
    },

    defaultFieldProps() {
      return {
        outlined: true
      }
    },

    defaultButtonProps() {
      return {
        block: true,
        color: 'primary'
      }
    },

    buildTag() {
      const env = process.env.VUE_APP_ENV;
      return `v${process.env.VUE_APP_VERSION}${env ? ` · ${env}` : ''}`;
    },

    cardProps() {
      return {
        class: 'px-5 py-8',
        color: 'background',
        width: '480px',
        style: 'border-radius: 15px'
      }
    }
  },

  methods: {
    ...mapMutations([
      "setStudio",
      "setTypeSlave",
      "setBrowserStudio",
      "setLogin",
    ]),

    ...mapActions([
      "loginBrowser", 
      "getStudios", 
      "checkToken"
    ]),

    async setTypeSlaveStore(type) {
      return this.setTypeSlave(type);
    },

    async getSudiosStore() {
      return await this.getStudios();
    },

    setEstudioStore(studio) {
      this.setStudio(studio);
    },

    resetLoginState() {
      this.loginError = false;
      this.email = '';
      this.password = '';
      this.totpToken = '';
      this.loginResponse = null;
    },

    async submit() {
      this.overlay = true;
      this.loginError = false;

      
      
      try {
        const response = await this.loginBrowser({
          email: this.email,
          password: this.password,
        });
        if (response.status === 401) {
          this.handleLoginError("Email o contraseña inválido");
          return;
        }
        if (response.status === 400) {
          this.handleLoginError("Ha ocurrido un error");
          return;
        }
        const {
          nextStep,
          uri,
          token
        } = response.data;
        if (nextStep === "First TOTP" || nextStep === "TOTP") {
          this.$refs.mfaDialog.open(nextStep === "First TOTP", uri);
          this.totpToken = token;
        }
        this.loginResponse = response;
      } catch (error) {
        console.error("Login error:", error);
        this.handleLoginError("Error inesperado de red o servidor");
      } finally {
        this.overlay = false;
      }
    },

    handleLoginError(message) {
      this.overlay = false;
      this.loginError = true;
      this.errorMsg = message;
    },

    async submitStudio() {
      await this.setBrowserStudio(this.select);
      if (!socketAutoConnectDisabled) this.$globalData.socket.connect();
      await this.setTypeSlaveStore("plus_remote");
      this.overlay2 = true;
    },

    fillStudios(studios) {
      this.items = [];
      studios.forEach((studio) => {
        if (studio.active == true) {
          const studioNumber = studio.name.charAt(studio.name.length - 1);
          studio.number = Number(studioNumber);
          this.items.push(studio);
        }
      });
    },

    async handleMfaVerified() {
      this.setLogin(true);
      const studios = await this.getStudios();
      this.fillStudios(studios.data);
      this.expand = false;
      setTimeout(() => {
        this.expand2 = true;
      }, 1000);
    },

    handleMfaCancelled() {
      this.resetLoginState();
    }
  },

  watch: {
    accessRemote() {
      if (this.accessRemote == true) {
        this.dialogMsg = "Acceso al Estudio: Entrando..."
        setTimeout(() => {
          this.$router.push("/slave")
        }, 2000);
      }
      if(this.accessRemote == false) {
        this.dialogMsg = "Acceso al Denegando: Saliendo..."
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    },
  },

  async mounted() {
    setTimeout(async () => {
      this.expand = true;
      const token = localStorage.getItem('token')
      const username = localStorage.getItem('currentUser')
      if(token != null && token != "null") {
        this.$store.commit("setTokenData", {token: token})
        this.$store.commit("setUsername", {userName: username})
        this.setLogin(true);
        this.expand = false;
        const studios = await this.getStudios();
        this.fillStudios(studios.data);
        this.overlay = false;
        setTimeout(() => {
          this.expand2 = true;
        }, 500);
      }
    }, 500);
    this.$store.state.role = "slave";
  },
};
</script>

<style scoped>
.login-view {
  position: relative;
  height: calc(100vh - 60px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.build-tag {
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
  text-align: center;
  user-select: text;
}
</style>